import {API} from '../API';

export class AccountFormService {

  async create(contact) {
    return (await API.getConnection())
      .post(`contacts/${contact.id}/account-forms`)
      .then(response => response.data.data)
      .catch(error => API.handleError(error));
  }

  async send(contact, form, name, email) {
    return (await API.getConnection())
      .post(`contacts/${contact.id}/account-forms/${form.id}/send`, {name, email})
      .then(response => response.data.data)
      .catch(error => API.handleError(error));
  }

  async complete(contact, form) {
    return (await API.getConnection())
      .post(`contacts/${contact.id}/account-forms/${form.id}`)
      .then(response => response.data.data)
      .catch(error => API.handleError(error));
  }

  async download(contact, form) {
    return (await API.getConnection())
      .get(`contacts/${contact.id}/account-forms/${form.id}/download`, {
        responseType: 'blob',
      })
      .then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', response.headers['x-filename']);
        document.body.appendChild(link);
        link.click();
      })
      .catch(error => API.handleError(error));
  }

  async delete(contact, form) {
    return (await API.getConnection())
      .delete(`contacts/${contact.id}/account-forms/${form.id}`)
      .then(response => response.data.data)
      .catch(error => API.handleError(error));
  }
}
